export default {
  message: {
    "error": "Uy! Nimadir noto'g'ri bo'ldi.",
    "Sorrysomeerrorsoccurred": "Kutilmagan xato yuz berdi. Siz tilni o'zgartirishni yoki ilovadan chiqishni va uni qayta ishga tushirishni sinab ko'rishingiz mumkin.",
    "quit": "Chiqish",
    "language": "Til",
    "Youcanchangethelanguagehere": "Tilni bu yerda o'zgartirishingiz mumkin!",
    "current": "Joriy",
    "home": "Bosh sahifa",
    "friends": "Dostlar",
    "wallet": "Hamyon",
    "aboutus": "Biz haqimizda",
    "Sharewithfriends": "Dostlar bilan bo'lishing",
    "copyFailure": "Ko'chirish muvaffaqiyatsiz",
    "copySuccess": "Ko'chirish muvaffaqiyatli",
    "Claimreward": "Mukofotni olish",
    "DailyLogin": "Har kuni kirish",
    "noInvitationsYet": "Hali takliflar yo'q",
    "LoadMore": "Ko'proq yuklash",
    "WatchAD": "Reklama ko'rish",
    "continue": "Davom etish",
    "Congratulations": "Tabriklaymiz",
    "MyFriends": "Menimcha dostlarim",
    "Invitefriends": "Dostlarni taklif qilish",
    "Invitepremiumfriends": "Premium dostlarni taklif qilish",
    "DailyTasks": "Kunlik vazifalar",
    "inviteDesc": "Har bir taklif etgan do'stingiz uchun +{num} ${name}",
    "DailyTasksDesc": "Vazifalarni bajarib, ko'proq airdrop oling",
    "SponsorsandPartners": "Homiylar va hamkorlar",
    "Receivingwallet": "Qabul qiluvchi hamyon",
    "Enterwalletaddress": "{name} hamyon manzilini kiriting",
    "Claim": "Olish",
    "Booster": "Tezlashtiruvchi",
    "RentPeriod": "Taqsimot davri",
    "days30": "30 kun",
    "Dailyprofit": "Kunlik daromad",
    "Totalprofit": "Jami daromad",
    "Quantity": "Soni",
    "RentPrice": "Ijaraga olish narxi",
    "RentMiner": "Xodimni ijaraga olish",
    "Insufficient": "Taklif qilinganlar yetarli emas",
    "InsufficientMsg": "Siz ko'proq aksessuarlar olish uchun {num} do'stlarni taklif qilishingiz kerak.",
    "Settings": "Sozlamalar",
    "copyid": "ID ni ko'chirish",
    "UpgradeSuccessfully": "Yangilandi muvaffaqiyatli",
    "Name": "Ism",
    "userinfo": "Foydalanuvchi ma'lumotlari",
    "disconnect": "Aloqani uzish",
    "Startmining": "Kon qazishni boshlash",
    "Welcome": "{name} ga xush kelibsiz",
    "Withdrawal": "Naqd pul olish",
    "Minimumamount": "Minimum miqdor",
    "Networkfee": "Tarmoq to'lovi",
    "Enteramount": "Miqdorni kiriting",
    "Submit": "Yuborish",
    "MinimumTip": "Naqd pul miqdori juda kichik. Minimal naqd pul miqdori: {num}",
    "MaximumTip": "Yetarli miqdor emas, siz chiqara oladigan maksimal miqdor: {num}",
    "SubmittedTip": "Yuborilgan, 30-60 ish kuni ichida ko'rib chiqilishi kutilyapti",
    "WebSubmittedTip": "Yuborilgan, imkon qadar tezroq ko'rib chiqamiz.",
    "WithdrawStatus": "Holat",
    "Submissiontime": "Yuborish vaqti",
    "WithdrawAwaitTip": "* Bu 30-60 ish kunini olishi taxmin qilinmoqda. Ko'proq do'stlarni taklif qilish ko'rib chiqish jarayonini tezlashtirishi mumkin.",
    "WebWithdrawAwaitTip": "* Bu 24-48 soat davom etishi taxmin qilinmoqda. Ko'proq do'stlarni taklif qilish ko'rib chiqish jarayonini tezlashtirishi mumkin.",
    "Processing": "Ko'rib chiqilmoqda",
    "Success": "Muvofaqqiyat",
    "Rejection": "Rad etish",
    "Amount": "Miqdor",
    "Numberoffriends": "Do'stlar soni: {now}/{limit}",
    "InviteTip": "Birinchi naqd pulingizni olish uchun {limit} do'stni mining ilovasiga taklif qilishingiz kerak.",
    "openonphone": "Bu havolani telefoningizda oching.",
    "claimTip": "Olishi kerak bo'lgan miqdor juda kichik. Olishi kerak bo'lgan minimal miqdor: {num}",
    "WalletBalance": "Hamyon Balansi",
    "Withdraw": "Naqd olish",
    "SetWalletAddress": "Hamyon Manzilini o'rnating",
    "WithdrawalRecord": "Naqd olish Yozuvi",
    "Norecords": "Yozuvlar yo'q",
    "Whatis": "{name} nima?",
    "All": "Hammasi",
    "save": "Saqlash",
    "successWithdrawal": "Skanner muvaffaqiyatli {num}",
    "secondsago": "{time} soniya oldin",
    "Loading": "Yuklanmoqda...",
    "PaymentConfirming": "Transaktsiya Holatini Tekshirish...",
    "Check": "Tekshirish",
    "CheckFail": "Transaktsiya tugallanmagan. Iltimos, 5 soniyadan keyin yana tekshiring.",
    "Addname": "Ismingizga '{name}' qo'shing",
    "Restattcheck": "Tekshirish uchun ilovani qayta ishga tushiring",
    "Copyname": "'{name}' ni nusxa oling",
    "SubmissionFailed": "Yuborish muvaffaqiyatsiz bo'ldi, iltimos, keyinroq qayta urinib ko'ring",
    "WithdrawalReview": "Naqd olish ko'rib chiqilishi",
    "select_payment_method": "To'lov usulini tanlang",
    "total_amount": "Jami miqdor",
    "next_step": "Keyingi qadam",
    "creating_order": "Buyurtma yaratilmoqda...",
    "order_created": "Buyurtma yaratildi",
    "order_status": "Buyurtma holati",
    "order_id": "Buyurtma ID",
    "order_amount": "Buyurtma miqdori",
    "order_status_desc": "Buyurtma holati ta'rifi",
    "payment_cancelled": "To'lov bekor qilindi",
    "opening_payment": "To'lovni ochish...",
    "payment_success": "To'lov muvaffaqiyatli",
    "payment_failed": "To'lov amalga oshmadi",
    "payment_pending": "To'lov kutishda",
    "payment_processing": "To'lov jarayoni",
    "create_order_failed": "Buyurtma yaratishda xato",
    "creating_ton_order": "TON buyurtmasini yaratish...",
    "check_payment_status": "To'lov holatini tekshirish...",
    "use_ton_payment": "TON to'lovni foydalaning",
    "connect_wallet": "Hamyonni ulash",
    "start_transaction": "Transaksiyani boshlash",
    "address": "Manzil",
    "amount_ton": "Miqdor TON",
    "copy": "Qayta nusxalash",
    "comment_memo": "Izoh memo",
    "comment_memo_desc": "Iltimos, izoh memo kiritishingizni so'raymiz",
    "comment_memo_placeholder": "Izoh memo kiritish",
    "amount": "Miqdor",
    "wallet_address": "Hamyon manzili",
    "you_can_choose_to_connect_wallet_to_pay": "To'lov uchun hamyonni ulashni tanlashingiz mumkin",
    "or_manually_transfer_to_the_above_address": "Yoki yuqoridagi manzilga qo'lda o'tkazishingiz mumkin (miqdor va memo aynan bir xil bo'lishi kerak)",
    "transaction_success": "Transaksiya muvaffaqiyatli",
    "transaction_failed": "Transaksiya amalga oshmadi",
    "transaction_error": "Transaksiya xato",
    "transaction_status": "Transaksiya holati",
    "transaction_id": "Transaksiya ID",
    "transaction_amount": "Transaksiya miqdori",
    "transaction_status_desc": "Transaksiya holati tavsifi",
    "miner_detail": "Miner tafsilotlari",
    "rent_period": "Ijaraga olish muddati",
    "days": "{days} kun",
    "daily_yield": "Kunlik daromad",
    "total_yield": "Jami daromad",
    "invite_friends": "Do'stlarni taklif qiling",
    "price": "Narx",
    "rent": "Ijaraga olish",
    "free_claim": "Bo'sh to'plang",
    "redeem": "Qayta sotish",
    "buy": "Ijaraga olish",
    "invite_friends_not_enough": "Do'stlarni taklif qilish yetarli emas",
    "redeem_success": "Qayta sotish muvaffaqiyatli",
    "redeem_failed": "Qayta sotish amalga oshmadi",
    "rent_success": "Ijaraga olish muvaffaqiyatli",
    "rent_failed": "Ijaraga olish amalga oshmadi",
    "TotalPower": "Jami Quvvat",
    "MaxQuantity": "Eng yuqori qiymat erishildi",
    "Running": "Bajarilmoqda",
    "Stop": "To'xtatish",
    "Withdrawalunlock": "Naqd pulni ochish",
    "Close": "Yopish",
    "Delivering": "Yetkazib berish",
    "Duetothelargenumber": "Qabul qiluvchilar sonining ko'pliligidan, sizning airdrop'ingiz 15-20 ish kunida yetib kelishi kutilmoqda",
    "WithdrawalunlockTip": "Naqd pulni ochish uchun vazifalarni bajarish/hamyonlarni bog'lash uchun {num} do'stni taklif qilishingiz kerak",
    "mining_title": "Robot",
    "Upgrade": "Yangilash",
    "partner": "Hamkor",
    "faq": "Tez-tez so'raladigan savollar",
    "task": "Vazifa",
    "OpenRobot": "Robotni ochish",
    "MyRobot": "Mening Robotim",
    "Level": "Daraja",
    "Commission": "Komissiya",
    "DirectFriends": "To'g'ridan-to'g'ri Do'stlar",
    "Feedback": "Fikr-mulohaza",
    "Pleaseenteryouremailaddress": "Iltimos, elektron pochta manzilingizni kiriting",
    "Inputfeedbackcontent": "Fikr-mulohaza mazmunini kiriting",
    "Submitfeedback": "Fikr-mulohazani yuborish",
    "Feedbacksubmittedsuccessfully,thankyouforyourvaluablefeedback": "Fikr-mulohaza muvaffaqiyatli yuborildi, qimmatli fikringiz uchun rahmat",
    "Feedbacksubmissionfailed,pleaseretriy": "Fikr-mulohaza yuborish muvaffaqiyatsiz, iltimos, qayta urinib ko'ring",
    "Addressformaterror": "Manzil formatida xato",
    "Readclipboardfailed": "Clipboard o'qilishi muvaffaqiyatsiz",
    "Youhavealreadyfeedbackedtoday,pleasecomebacktomorrow": "Bugun allaqachon fikr bildirdingiz, iltimos, ertaga qaytaring",
    "Record": "Hisob",
    "Newuserguidance": "Xush kelibsiz sayohatini ko'ring",
    "Usetonwallet": "TON hamyonidan foydalaning",
    "Reward": "Mukofot",
    "Connectwallet": "Hamyonni ulash",
    "Notconnected": "Ulanmagan",
    "Disconnect": "Ulanishni uzish",
    "AboutTAI": "Token Tafsilotlari",
    "WithdrawalRecordDesc": "Pullarni chiqarish hisobi",
    "StartAItrading": "AI savdosini boshlash",
    "Next": "Keyingi",
    "Start": "Boshlash",
    "WithdrawalSuccess": "Pullarni chiqarish muvaffaqiyati",
    "WithdrawalFail": "Pullarni chiqarish muvaffaqiyatsiz",
    "Max": "Eng ko'p",
    "WithdrawalRecords": "Pullarni chiqarish hisoblari",
    "Commissionrules": "Komissiya qoidalari",
    "Mycommission": "Menimcha komissiya",
    "Shop": "Do'kon",
    "BuyDifferentAIrobots": "Tezroq skanerlash uchun hisoblash qurilmalari bilan yangilang!",
    "CurrentRunningAIrobots": "Joriy faol AI robotlar",
    "DailyProfit": "Kunlik foyda",
    "Buy": "Sotib oling",
    "ValidityPeriod": "Amal qilish muddati",
    "Days": "Kunlar",
    "Price": "Narx",
    "APY": "APY",
    "NoRobot": "Hisoblash quvvati yo'q",
    "RemainingTime": "Qolgan vaqt",
    "InviteandEarn": "Taklif qil va daromad ol",
    "InvitDec": "Dostonlarizni AI savdosiga taklif qiling va USDT komissiyalari va airdrop tokenlarini birgalikda oling!",
    "ShareToGroups": "Guruhlarga ulashing",
    "Select_payment_method": "To'lov usulini tanlang",
    "twa_pay_tip_with_memo": "Iltimos, manzil, miqdor va eslatma uzatish uchun mos ekanligini ta'minlang.",
    "twa_pay_tip": "Iltimos, manzil va miqdor uzatish uchun to'g'ri ekanligini ta'minlang.",
    "twa_pay_tip_placeholder": "Izohni kiriting",
    "twa_pay_tip_placeholder_with_memo": "Izohni va eslatmani kiriting",
    "twa_pay_tip_placeholder_without_memo": "Izohni eslatmasiz kiriting",
    "twa_pay_tip_placeholder_with_memo_placeholder": "Izohni eslatma bilan kiriting",
    "twa_pay_tip_placeholder_without_memo_placeholder": "Izohni eslatmasiz kiriting",
    "realtime_ai": "Real-Vaqt AI Savdosi",
    "check_transaction_status": "Transaction holatini tekshiring",
    "transaction_wait": "Transaction jarayonda. Siz dasturdan chiqishingiz mumkin. Bu tugagach, sizga xabar beriladi.",
    "Pleaseenteravalidemailaddress": "Iltimos, to'g'ri elektron pochta manzilini kiriting",
    "max_robot_tip": "Sotib olish chekloviga yetdingiz — savdoni davom ettirish uchun boshqa reja tanlang!",
    "connectFailure": "Hamyonni ulash muvaffaqiyatsiz",
    "connectSuccess": "Hamyonni ulash muvaffaqiyatli",
    "PayNow": "Hoziroq to'lash",
    "min_withdrawal_amount": "Eng kam pul yechish miqdori {num} {coin_name}",
    "max_withdrawal_amount": "Eng ko'p pul yechish miqdori {num} {coin_name}",
    "balance_not_enough": "Bu yechish uchun yetarli balansingiz yo'q.",
    "Numberofgroups": "Guruqlar soni: {now}/{limit}",
    "Withdraw_success": "Yechish muvaffaqiyatli",
    "allProfit": "Umumiy foyda",
    "AnnualProfit": "Yillik foyda",
    "ScanWallet": "Hamyonni skanerlash",
    "wallet_check": "hamyon_tekshirish",
    "Found": "Topildi",
    "ScanSpeed": "Skanerlash tezligi",
    "MyComputingPower": "Hisoblash",
    "Scanning": "Skanning!",
    "WithdrawDetail": "Pul o'tkazish tafsilotlari",
    "ScanSuccess": "Skanningizning muvaffaqiyat darajasi oshdi!",
    "TaskDescription": "Skanner muvaffaqiyati darajangizni oshirish uchun vazifalarni bajaring!",
    "InitializingMiningSystem": "Skanner tizimini ishga tushirish...",
    "NoWithdrawalRecord": "Hech qanday yechib olish qaydnomasi yo'q",
    "Invite": "Talab qilinadigan takliflar",
    "Free": "Bepul",
    "Confirm": "Tasdiqlang",
    "RefreshTasks": "Vazifalarni yangilang",
    "NumberofGroups": "Gruplar soni: {now}/{limit}",
    "SendMessage": "Xabar yuborish",
    "NumberofShares": "Ulushlar soni: {now}/{limit}",
    "NumberofTasks": "Vazifalar soni: {now}/{limit}",
    "CompleteTask": "Vazifani bajarish",
    "Accelerated": "Tezlashtirilgan",
    "Accelerated_withdrawals_success": "Tezlashtirilgan to'lovlar muvaffaqiyatli",
    "GoBuy": "Kimning sotib olish",
    "SpeedUpScan": "Tezlashtirish",
    "Earnings": "Daromadlar",
    "learnMore": "Batafsil ma'lumot",
    "claimSuccess": "Muvofaqiyatli topildi",
    "claimFailed": "Topish muvaffaqiyatsiz bo'ldi, iltimos qaytadan urinib ko'ring",
    "noDividends": "Topiladigan dividendlar yo'q",
    "dividendsInfoFallback": "Dostlarni taklif qilish orqali tavsiya mukofotlarini oling"
}};